export enum RoblexModalFooterAlign {
    start = 'start',
    end = 'end',
    stretch = 'stretch',
    center = 'center'
}
